import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const IconContentCard = (props) => {


    return (
        <div className="iconContentCard-container shadow-lg">
            <div className="iconContentCard-icon" 
                style={
                    props.variant === 'error' ? {background:'#dc3545'}
                    :
                    props.variant === 'primary' ? {background: '#0d6efd'}
                    :
                    props.variant === 'warning' ? {background: '#ffc107'}
                    :
                    {background: '#a2c13f'}
                }>
                <div>
                    {props.icon}
                </div>
            </div>
            <div className="iconContentCard-content">
                {props.children}
            </div>
        </div>
    )
}

export default IconContentCard;